import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-872fddd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "formsContainer" }
const _hoisted_2 = { class: "formsContainer__header" }
const _hoisted_3 = { class: "formsContainer__body" }
const _hoisted_4 = { class: "userForm" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Creación de usuarios", -1))
const _hoisted_6 = { class: "enterpriseForm" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Creación de empresas", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderApp = _resolveComponent("HeaderApp")!
  const _component_UserForm = _resolveComponent("UserForm")!
  const _component_EnterpriseForm = _resolveComponent("EnterpriseForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_HeaderApp, { "header-type": 'management' })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_UserForm, { "used-for": 'creation' })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_EnterpriseForm, { "used-for": 'creation' })
      ])
    ])
  ]))
}